export default "__VITE_PUBLIC_ASSET__c4b7ece0__"